import React from 'react';
import PropTypes from 'prop-types';
import SearchShowMore from '../SearchShowMore';
import SearchDropdownSorting from '../SearchDropdownSorting';
import SearchViewSwitch from '../SearchViewSwitch';
import SearchResultItem from '../SearchResultItem';
import Loader from '../Loader';
import { useContextState } from '../StateProvider';
import { useTranslation } from 'next-i18next';
import styles from './SearchResults.module.scss';

const SearchResults = ({ items = [] }) => {
    const { t } = useTranslation('common');
    const [{ meta: { totalHits } = {}, isMap, searching } = {}] = useContextState();
    return (
        <div className={styles['SearchResults']}>
            <div className={styles['SearchResults__Wrapper']}>
                <h2 className={styles['SearchResults__Info']}>
                    {isMap
                        ? // Numbers of POIs might be different to number of articles
                          t('mapFilter.hitsHeadline', {
                              totalHits: items.length,
                          })
                        : t('search.hitsHeadline', { totalHits })}
                </h2>
                <div className={styles['SearchResults__Actions']}>
                    <SearchDropdownSorting />
                    <SearchViewSwitch />
                </div>
                <div className={styles['SearchResults__Results']} role="alert">
                    {items.map((item) => {
                        return <SearchResultItem key={item.id} {...item} />;
                    })}
                </div>
            </div>
            {searching && <Loader />}
            <SearchShowMore />
        </div>
    );
};

SearchResults.propTypes = {
    items: PropTypes.array,
};

export default SearchResults;
